module.exports = __webpack_public_path__ + "img/phase1-2011-01.7e8c2667.jpg";